/**
 * Products List Slider - Swiper initialization
 */

class ProductsListSlider {
  constructor() {
    this.initSwiper();
  }

  initSwiper() {
    const swiperElements = document.querySelectorAll('[data-swiper-products]');

    swiperElements.forEach((element) => {
      const swiper = new Swiper(element, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        speed: 600,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductsListSlider();
  });
} else {
  new ProductsListSlider();
}

// Expose class globally for dynamic initialization
window.ProductsListSlider = ProductsListSlider;
